import axios from 'axios'

export default {
  async getPrice() {
    return axios.get('/price')
  }
}
